export function getStatusColor(status) {
  const map = {
    fit: "text-green-400 bg-green-400/10 border border-green-400/20",
    caution: "text-amber-400 bg-amber-400/10 border border-amber-400/20",
    high_risk: "text-red-400 bg-red-400/10 border border-red-400/20",
    do_not_assign: "text-red-300 bg-red-900/30 border border-red-500/40",
  };
  return map[status] || "text-muted-foreground bg-muted/30";
}

export function getStatusLabel(status) {
  const map = {
    fit: "FIT",
    caution: "CAUTION",
    high_risk: "HIGH RISK",
    do_not_assign: "DO NOT ASSIGN",
  };
  return map[status] || status?.toUpperCase();
}

export function getScoreColor(score) {
  if (score >= 81) return "text-red-300";
  if (score >= 61) return "text-red-400";
  if (score >= 31) return "text-amber-400";
  return "text-green-400";
}

export function getSeverityStyle(severity) {
  const map = {
    critical: "border-red-500 text-red-400 bg-red-400/10",
    high: "border-orange-500 text-orange-400 bg-orange-400/10",
    medium: "border-amber-500 text-amber-400 bg-amber-400/10",
    low: "border-slate-500 text-slate-400 bg-slate-400/10",
  };
  return map[severity] || "border-border text-muted-foreground";
}

export function FatigueStatusBadge({ status }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-sm text-xs font-bold tracking-wider font-mono ${getStatusColor(status)}`}>
      {getStatusLabel(status)}
    </span>
  );
}

export function ScoreDisplay({ score }) {
  return (
    <span className={`font-mono font-medium text-sm ${getScoreColor(score)}`}>
      {score}
    </span>
  );
}
